import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {UserRole} from '@association/_common/models/user-role.models';

export const LoadList = createAction(
    '[UserRoles] Load List',
    props<{ payload: { loading: DahLoadingType } }>()
);

export const LoadListSuccess = createAction(
    '[UserRoles] Load List Success',
    props<{ payload: { items: UserRole[], pagination: DahPaginationModel } }>()
);

export const LoadListFailure = createAction(
    '[UserRoles] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetLoading = createAction(
    '[UserRoles] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[UserRoles] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[UserRoles] Update Item Success',
    props<{ payload: UserRole }>()
);

export const DeleteItem = createAction(
    '[UserRoles] Delete Item',
    props<{ payload: UserRole }>()
);

export const DeleteItemSuccess = createAction(
    '[UserRoles] Delete Item Success',
    props<{ payload: UserRole }>()
);

export const DeleteItemFailure = createAction(
    '[UserRoles] Delete Item Failure',
    props<{ payload: UserRole }>()
);

export const SetInitialState = createAction(
    '[UserRoles] Set Initial State'
);
